import { useRouter } from "next/router";

import useMediaQuery   from "_common/hooks/useMediaQuery";
import { isPageRoute } from "_common/utils";
import useFirestore    from "_components/features/chat/container/useFirestore";
import useIVSChatRoom  from "_components/features/ivsChat";

const ConnectChat = ( { broadcastData } ) => {
	const router       = useRouter ();
	const isStreamPage = isPageRoute ( { router, page: "stream" } );
	const isStudioPage = isPageRoute ( { router, page: "studio" } );
	const isPopoutPage = isPageRoute ( { router, page: "popout" } );

	const isLive           = !broadcastData?.endTimeUTC || false;
	const connectIVSChat   = broadcastData?.ivsChatEnabled && ( isStudioPage || isPopoutPage || ( isStreamPage && isLive ) ) ? true : false;
	const connectFirestore = !broadcastData?.ivsChatEnabled && ( isStudioPage || isPopoutPage || ( isStreamPage && isLive ) ) ? true : false;

	useMediaQuery ();
	useIVSChatRoom ( connectIVSChat );
	useFirestore ( connectFirestore );

	return null;
};

export default ConnectChat;
